export const environment = {
  production: true,
  serviceUrl: 'https://dev-worksenseservice.ustechsupplierportal.com/'
};
